/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ** CREATIVE POPUPS

// Get the modal
var homemodal = document.getElementById("homePop");

// Get the button that opens the modal
var homebtn = document.getElementById("homeBtn");

// Get the <span> element that closes the modal
var homeclose = document.getElementById("homeClose");

// When the user clicks the button, open the modal 
homebtn.onclick = function() {
  homemodal.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
homeclose.onclick = function() {
  homemodal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == homemodal) {
    homemodal.style.display = "none";
  }
}






